module.exports = __webpack_public_path__ + "media/site/images/map-blank-4a601bf65db5a32ce530af7c3ad06f66.svg";